<fieldset *ngIf="form as form" [formGroup]="form">
  <legend>
    Informacje o nieruchomości
  </legend>
  <div class="row">
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"propertyLegalTitle" as controlName'>
        <label [for]='controlName'>
          Tytuł prawny do nieruchomości *
        </label>
        <select
          (change)="form.propertyLegalTitleChange(form.getElement($event).value)"
          [id]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [formControlName]='controlName'>
          <option value=''>Wybierz</option>
          <option [value]='item.id' *ngFor='let item of form.propertyLegalTitles'>
            {{ item.name }}
          </option>
        </select>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    @if (form.propertyLegalTitleDesc) {
      <div class='col-md-6' *ngIf='"propertyLegalTitleDesc" as controlName'>
        <div class='form-group' *ngIf="form.get(controlName)">
          <label [for]='controlName'>
            Inny tytuł prawny *
          </label>
          <textarea
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu inny tytuł prawny'></textarea>
          <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    }
  </div>
  <div class="row">
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"purposeOfUse" as controlName'>
        <label [for]='controlName'>
          Obecny sposób wykorzystania nieruchomości *
        </label>
        <select
          (change)="form.purposeOfUseChange(form.getElement($event).value)"
          [id]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [formControlName]='controlName'>
          <option value=''>Wybierz</option>
          <option [value]='item' *ngFor='let item of form.purposeOfUseList'>
            {{ item }}
          </option>
        </select>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    @if (form.purposeOfUseDesc) {
      <div class='col-md-6' *ngIf='"purposeOfUseDesc" as controlName'>
        <div class='form-group' *ngIf="form.get(controlName)">
          <label [for]='controlName'>
            Inny sposób *
          </label>
          <textarea
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu inny sposób'></textarea>
          <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    }
  </div>
  <div class="row">
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"postInvestmentUsage" as controlName'>
        <label [for]='controlName'>
          Sposób wykorzystania nieruchomości po wybudowaniu zjazdu *
        </label>
        <select
          (change)="form.postInvestmentUsageChange(form.getElement($event).value)"
          [id]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [formControlName]='controlName'>
          <option value=''>Wybierz</option>
          <option [value]='item' *ngFor='let item of form.postInvestmentUsages'>
            {{ item }}
          </option>
        </select>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-6' *ngIf='"propertyUsageChange" as controlName'>
      <div class='form-group' *ngIf="form.get(controlName)">
        <label [for]='controlName'>
          Zmiana wykorzystania nieruchomości *
        </label>
        <textarea
          [id]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [formControlName]='controlName'
          placeholder='Opisz tu zmiany wykorzystania nieruchomości'></textarea>
        <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
  </div>
  <div class="row">
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"referenceVehicleType" as controlName'>
        <label [for]='controlName'>
          <br>Rodzaj pojazdu miarodajnego, <br> który będzie obsługiwał zjazd *
        </label>
        <select
          [id]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [formControlName]='controlName'>
          <option value=''>Wybierz</option>
          <option value='Pojazd osobowy'>Pojazd osobowy</option>
          <option value='Pojazd komunalny'>Pojazd komunalny</option>
          <option value='Pojazd ciężarowy bez przyczepy'>Pojazd ciężarowy bez przyczepy</option>
          <option value='Pojazd ciężarowy z przyczepą'>Pojazd ciężarowy z przyczepą</option>
          <option value='Ciągnik rolniczy z dwiema przyczepami'>Ciągnik rolniczy z dwiema przyczepami</option>
          <option value='Autobus dwuosiowy'>Autobus dwuosiowy</option>
          <option value='Autobus trzyosiowy'>Autobus trzyosiowy</option>
          <option value='Autobus przegubowy'>Autobus przegubowy</option>
        </select>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
    <div class='col-md-4'>
      <div class='form-group' *ngIf='"propertyParkingSpacesCount" as controlName'>
        <label [for]='controlName'>
          Liczba stanowisk postojowych na <br> terenie nieruchomości do <br> której prowadził będzie zjazd *
        </label>
        <input
          [id]='controlName'
          [ngClass]='{ "is-invalid": form.showError(controlName) }'
          [formControlName]='controlName'
          mask="0*"
          placeholder='Wpisz tu liczbę stanowisk'
          type='text'>
        <app-validation-errors [control]='form.get(controlName)'>
        </app-validation-errors>
      </div>
    </div>
  </div>
</fieldset>
